import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'


const routes: Array<RouteRecordRaw> = [

    // app navigation
    {
        path: '/',
        name: 'home',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "home" */ '@/views/HomeView.vue')
    },
    {
        path: '/keep-merger-filers-up-to-date/:token',
        name: 'guideConfirmUpdate',
        props: true,
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "guide" */ '@/views/guides/ConfirmGuideUpdateView.vue')
    },

    {
        path: '/guide/merger-control',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "guidemerge" */ '@/views/guides/mergercontrol/MergerControlView.vue'),
        children: [
            {
                path: '',
                name: 'mergerControl',
                meta: {
                    module: 'app',
                    access: 'public'
                },
                component: () => import(/* webpackChunkName: "guidemerge" */ '@/views/guides/mergercontrol/FullCountryChaptersTab.vue'),
            },
            {
                path: 'search',
                name: 'mergerControlSearch',
                meta: {
                    module: 'app',
                    access: 'public'
                },
                component: () => import(/* webpackChunkName: "guidemerge" */ '@/views/guides/mergercontrol/PickChooseTab.vue'),
            },
            {
                path: ':countrySlug',
                name: 'mergerControlCountry',
                props: true,
                meta: {
                    module: 'app',
                    access: 'public'
                },
                component: () => import(/* webpackChunkName: "guidemerge" */ '@/views/guides/mergercontrol/FullCountryChaptersTab.vue'),
            },
        ]
    },
    {
        path: '/guide/foreign-investments',
        name: 'foreignInvestments',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "guideforeign" */ '@/views/guides/foreigninvestments/ForeignInvestmentsView.vue'),
    },
    {
        path: '/guide/foreign-investments/:countrySlug',
        name: 'foreignInvestmentsCountry',
        props: true,
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "guideforeign" */ '@/views/guides/foreigninvestments/ForeignInvestmentsView.vue'),
    },

    {
        path: '/decisions',
        name: 'decisions',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "decisions" */ '@/views/DecisionsView.vue')
    },
    {
        path: '/decisions/:decisionUrlSlug',
        name: 'decisionViewOpen',
        props: true,
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "decisions" */ '@/views/DecisionsView.vue')
    },
    {
        path: '/articles',
        name: 'articles',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "articles" */ '@/views/ArticlesView.vue'),
    },
    {
        path: '/articles/:urlSlug',
        name: 'articleView',
        props: true,
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "articles" */ '@/views/ArticlesView.vue'),
    },
    {
        path: '/maia',
        name: 'maia',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "maia" */ '@/views/MaiAView.vue'),
    },

    {
        path: '/news',
        name: 'newsView',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "news" */ '@/views/NewsView.vue'),
    },
    {
        path: '/news/:urlSlug',
        name: 'newsDetailView',
        props: true,
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "news" */ '@/views/NewsView.vue'),
    },

    {
        path: '/jobs',
        name: 'jobsView',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "jobs" */ '@/views/JobsView.vue'),
    },
    {
        path: '/jobs/:urlSlug',
        name: 'jobsDetailView',
        props: true,
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "jobs" */ '@/views/JobsView.vue'),
    },


    {
        path: '/experts/merger-control',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "expertsmerger" */ '@/views/experts/ExpertsView.vue'),
        children: [
            {
                path: 'lawyers',
                name: 'expertsLayers',
                meta: {
                    module: 'app',
                    access: 'public'
                },
                component: () => import(/* webpackChunkName: "expertsmerger" */ '@/views/experts/ExpertLawyersSection.vue'),
            },
            {
                path: 'lawyers/specific/:uuid',
                name: 'expertsLayersOpen',
                meta: {
                    module: 'app',
                    access: 'public',
                    preserveScroll: true
                },
                component: () => import(/* webpackChunkName: "expertsmerger" */ '@/views/experts/ExpertLawyersSection.vue'),
                props: true
            },
            {
                path: 'lawyers/:jurisdictionSlug',
                name: 'expertsLawyersJurisdiction',
                meta: {
                    module: 'app',
                    access: 'public',
                    preserveScroll: true
                },
                component: () => import(/* webpackChunkName: "expertsmerger" */ '@/views/experts/ExpertLawyersSection.vue'),
                props: true
            },
            {
                path: 'economists',
                name: 'expertsEconomists',
                meta: {
                    module: 'app',
                    access: 'public'
                },
                component: () => import(/* webpackChunkName: "expertsmerger" */ '@/views/experts/ExpertEconomistsSection.vue'),
            },
            {
                path: 'economists/:companyName',
                name: 'expertsEconomistCompany',
                meta: {
                    module: 'app',
                    access: 'public',
                    preserveScroll: true
                },
                component: () => import(/* webpackChunkName: "expertsmerger" */ '@/views/experts/ExpertEconomistsSection.vue'),
                props: true
            },
        ]
    },
    {
        path: '/experts/foreign-investments',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "expertsforeign" */ '@/views/experts/ExpertsForeignView.vue'),
        children: [
            {
                path: 'lawyers',
                name: 'expertsForeignLawyers',
                meta: {
                    module: 'app',
                    access: 'public'
                },
                component: () => import(/* webpackChunkName: "expertsforeign" */ '@/views/experts/ExpertForeignLawyersSection.vue'),
            }, {
                path: 'lawyers/specific/:uuid',
                name: 'expertsForeignLawyerOpen',
                props: true,
                meta: {
                    module: 'app',
                    access: 'public',
                    preserveScroll: true
                },
                component: () => import(/* webpackChunkName: "expertsforeign" */ '@/views/experts/ExpertForeignLawyersSection.vue'),
            }, {
                path: 'lawyers/:jurisdictionSlug',
                name: 'expertsForeignLawyersJurisdiction',
                props: true,
                meta: {
                    module: 'app',
                    access: 'public',
                    preserveScroll: true
                },
                component: () => import(/* webpackChunkName: "expertsforeign" */ '@/views/experts/ExpertForeignLawyersSection.vue'),
            },
        ]
    },
    {
        path: '/authorities',
        redirect: {name: 'authoritiesCompetition'}
    },
    {
        path: '/authorities/competition',
        name: 'authoritiesCompetition',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "authorities" */ '@/views/authorities/AuthoritiesView.vue'),
        props: {
            view: 'competition',
        }
    },
    {
        path: '/authorities/competition/:jurisdictionSlug',
        name: 'authoritiesCompetitionJurisdiction',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "authorities" */ '@/views/authorities/AuthoritiesView.vue'),
        props: {
            view: 'competition',
        }
    },
    {
        path: '/authorities/foreign-investments',
        name: 'authoritiesForeignInvestments',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "authorities" */ '@/views/authorities/AuthoritiesView.vue'),
        props: {
            view: 'foreign-investments',
        }
    },
    {
        path: '/authorities/foreign-investments/:jurisdictionSlug',
        name: 'authoritiesForeignInvestmentsJurisdiction',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "authorities" */ '@/views/authorities/AuthoritiesView.vue'),
        props: {
            view: 'foreign-investments',
        }
    },
    {
        path: '/events',
        name: 'events',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "events" */ '@/views/EventsView.vue')
    },
    {
        path: '/newsletter/:token/subscribe',
        name: 'subscribeNewsletterSuccess',
        props: true,
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "subscribenewsletter" */ '@/views/SubscribeNewsletterView.vue')
    },
    {
        path: '/newsletter/:token/unsubscribe',
        name: 'unsubscribeNewsletterSuccess',
        props: true,
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "subscribenewsletter" */ '@/views/UnsubscribeNewsletterView.vue')
    },

    {
        path: '/about',
        name: 'about',
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/AboutView.vue')
    },
    {
        path: '/admin',
        meta: {
            module: 'admin',
            access: 'private',
        },
        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/AdminModule.vue'),
        children: [
            {
                path: 'dashboard',
                name: 'dashboard',
                meta: {
                    module: 'admin'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/DashboardView.vue')
            },
            {
                path: 'users',
                meta: {
                    module: 'admin',
                    access: 'private',
                    submodule: 'users'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/users/UsersModule.vue'),
                children: [
                    {
                        path: 'administrators',
                        name: 'usersAdminList',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'users'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/users/UsersAdministratorsList.vue'),
                    },
                    {
                        path: 'contributors',
                        name: 'usersContributorsList',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'users'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/users/UsersContributorsList.vue'),
                    },
                    {
                        path: 'economists',
                        name: 'usersEconomistsList',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'users'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/users/UsersEconomistsList.vue'),
                    },

                ]
            },
            {
                path: 'news',
                meta: {
                    module: 'admin',
                    access: 'private',
                    submodule: 'news'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/news/NewsModule.vue'),
                children: [
                    {
                        path: '',
                        name: 'newsList',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'news'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/news/NewsListPanel.vue'),
                    },
                    {
                        path: 'create',
                        name: 'createNews',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'news'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/news/NewsPanel.vue'),
                    },
                    {
                        path: ':uuid/edit',
                        name: 'editNews',
                        props: true,
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'news'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/news/NewsPanel.vue'),
                    },

                ]
            },
            {
                path: 'events',
                meta: {
                    module: 'admin',
                    access: 'private',
                    submodule: 'events'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/events/EventsModule.vue'),
                children: [
                    {
                        path: '',
                        name: 'eventsList',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'events'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/events/EventsListPanel.vue'),
                    },
                    {
                        path: 'create',
                        name: 'createEvent',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'events'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/events/EventPanel.vue'),
                    },
                    {
                        path: ':uuid/edit',
                        name: 'editEvent',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'events'
                        },
                        props: true,
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/events/EventPanel.vue'),
                    },

                ]
            },
            {
                path: 'articles',
                meta: {
                    module: 'admin',
                    access: 'private',
                    submodule: 'articles'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/articles/ArticlesModule.vue'),
                children: [
                    {
                        path: '',
                        name: 'articlesList',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'articles'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/articles/ArticlesListPanel.vue'),
                    },
                    {
                        path: 'create',
                        name: 'createArticle',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'articles'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/articles/ArticlesPanel.vue'),
                    },
                    {
                        path: ':uuid/edit',
                        name: 'editArticle',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'articles'
                        },
                        props: true,
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/articles/ArticlesPanel.vue'),
                    },

                ]
            },
            {
                path: 'jurisdictions',
                name: 'jurisdictions',
                meta: {
                    module: 'admin'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/JurisdictionsPanel.vue')
            },
            {
                path: 'authorities',
                meta: {
                    module: 'admin',
                    access: 'private',
                    submodule: 'authorities'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/competitionauthorities/CompetitionAuthoritiesModule.vue'),
                children: [
                    {
                        path: '',
                        name: 'competitionAuthorities',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'authorities'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/competitionauthorities/CompetitionAuthoritiesList.vue'),
                    },
                    {
                        path: 'create',
                        name: 'createCompetitionAuthority',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'authorities'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/competitionauthorities/CompetitionAuthorityPanel.vue'),
                    },
                    {
                        path: ':uuid/edit',
                        name: 'editCompetitionAuthority', meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'authorities'
                        },

                        props: true,
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/competitionauthorities/CompetitionAuthorityPanel.vue'),
                    },

                ]
            },
            {
                path: 'decisions',
                meta: {
                    module: 'admin',
                    access: 'private',
                    submodule: 'decisions'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/decisions/DecisionsModule.vue'),
                children: [
                    {
                        path: '',
                        name: 'decisionsListView',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'decisions'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/decisions/DecisionsListView.vue'),
                    },
                    {
                        path: 'create',
                        name: 'decisionCreate',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'decisions'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/decisions/DecisionDataView.vue'),
                    },
                    {
                        path: ':uuid/edit',
                        name: 'decisionEdit',
                        props: true,
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'decisions'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/decisions/DecisionDataView.vue'),
                    },


                ]
            },
            {
                path: 'experts',
                name: 'ExpertsAdminModule',
                meta: {
                    module: 'admin',
                    access: 'private',
                    submodule: 'experts'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/experts/ExpertsAdminModule.vue'),
                children: [
                    {
                        path: 'law-firms',
                        name: 'lawFirmsListView',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'experts',
                            section: 'lawfirm'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/experts/lawfirms/LawFirmsListPanel.vue'),
                    },
                    {
                        path: 'law-firms/create',
                        name: 'lawFirmsCreate',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'experts',
                            section: 'lawfirm'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/experts/lawfirms/LawFirmDataPanel.vue'),
                    },
                    {
                        path: 'law-firms/:uuid/edit',
                        name: 'lawFirmsEdit',
                        props: true,
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'experts',
                            section: 'lawfirm'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/experts/lawfirms/LawFirmDataPanel.vue'),
                    },
                    {
                        path: 'lawyers',
                        name: 'lawyersListView',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'experts',
                            section: 'lawyers'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/experts/lawyers/LawyersListPanel.vue'),
                    },
                    {
                        path: 'lawyers/create',
                        name: 'lawyersCreate',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'experts',
                            section: 'lawyers'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/experts/lawyers/LawyerDataPanel.vue'),
                    },
                    {
                        path: 'lawyers/:uuid/edit',
                        name: 'lawyersEdit',
                        props: true,
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'experts',
                            section: 'lawyers'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/experts/lawyers/LawyerDataPanel.vue'),
                    },
                    {
                        path: 'economist-consultancy',
                        name: 'economistsConsultancyListView',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'experts',
                            section: 'economistconsultancy'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/experts/economistconsultancy/EconomistConsultancyListPanel.vue'),
                    },
                    {
                        path: 'economist-consultancy/create',
                        name: 'economistsConsultancyCreate',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'experts',
                            section: 'economistconsultancy'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/experts/economistconsultancy/EconomistConsultancyDataPanel.vue'),
                    },
                    {
                        path: 'economist-consultancy/:uuid/edit',
                        name: 'economistsConsultancyEdit',
                        props: true,
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'experts',
                            section: 'economistconsultancy'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/experts/economistconsultancy/EconomistConsultancyDataPanel.vue'),
                    },
                    {
                        path: 'economists',
                        name: 'economistsListView',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'experts',
                            section: 'economists'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/experts/economists/EconomistsListPanel.vue'),
                    },
                    {
                        path: 'economists/create',
                        name: 'economistCreate',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'experts',
                            section: 'economists'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/experts/economists/EconomistDataPanel.vue'),
                    },
                    {
                        path: 'economists/:uuid/edit',
                        name: 'economistEdit',
                        props: true,
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'experts',
                            section: 'economists'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/experts/economists/EconomistDataPanel.vue'),
                    },
                ]
            },
            {
                path: 'guides/merger-control',
                meta: {
                    module: 'admin',
                    access: 'private',
                    submodule: 'guidesmerger'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/guides/mergercontrol/MergerControlNavtabs.vue'),
                children: [
                    {
                        path: 'headings',
                        name: 'mergerHeadings',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'guidesmerger',
                            section: 'headings'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/guides/mergercontrol/MergerControlTopicsList.vue')
                    },
                    {
                        path: 'topics',
                        name: 'mergerTopics',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'guidesmerger',
                            section: 'topics'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/guides/mergercontrol/MergerControlQuestionsList.vue')
                    },
                    {
                        path: 'guide',
                        name: 'mergerGuide',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'guidesmerger',
                            section: 'guide'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/guides/mergercontrol/MergerControlGuidePanel.vue')
                    },
                    {
                        path: ':uuid/regulation',
                        name: 'mergerGuideRegulation',
                        props: true,
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'guidesmerger',
                            section: 'guide'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/guides/mergercontrol/MergerControlRegulationPanel.vue')
                    },
                ]
            },
            {
                path: 'guides/foreign-investments',
                meta: {
                    module: 'admin',
                    access: 'private',
                    submodule: 'guidesforeign'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/guides/foreigninvestments/ForeignInvestmentsNavtabs.vue'),
                children: [
                    {
                        path: 'headings',
                        name: 'foreignHeadings',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'guidesforeign',
                            section: 'headings'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/guides/foreigninvestments/ForeignInvestmentsTopicsList.vue')
                    },
                    {
                        path: 'topics',
                        name: 'foreignTopics',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'guidesforeign',
                            section: 'topics'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/guides/foreigninvestments/ForeignInvestmentsQuestionsList.vue')
                    },
                    {
                        path: 'guide',
                        name: 'foreignGuide',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'guidesforeign',
                            section: 'guide'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/guides/foreigninvestments/ForeignInvestmentsGuidePanel.vue')
                    },
                    {
                        path: ':uuid/regulation',
                        name: 'foreignGuideRegulation',
                        props: true,
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'guidesforeign',
                            section: 'guide'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/guides/foreigninvestments/ForeignInvestmentsRegulationPanel.vue')
                    },

                ]
            },

            {
                path: 'newsletter',
                meta: {
                    module: 'admin',
                    access: 'private',
                    submodule: 'newsletter'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/newsletter/NewsletterModule.vue'),
                children: [
                    {
                        path: 'mailing-list',
                        name: 'mailingListAdmin',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'newsletter'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/newsletter/MailingListView.vue'),
                    },
                    {
                        path: 'management',
                        name: 'newsletterAdmin',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'newsletter'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/newsletter/NewsletterManagement.vue'),
                    },

                ]
            },
            {
                path: 'analytics',
                name: 'analytics',
                meta: {
                    module: 'admin',
                    access: 'private',
                    submodule: 'analytics'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/AnalyticsPanel.vue'),
            },
            {
                path: 'jobs',
                meta: {
                    module: 'admin',
                    access: 'private',
                    submodule: 'jobs'
                },
                component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/jobs/JobsModule.vue'),
                children: [
                    {
                        path: '',
                        name: 'jobsList',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'jobs'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/jobs/JobsListPanel.vue'),
                    },
                    {
                        path: 'create',
                        name: 'createJob',
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'jobs'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/jobs/JobsDataPanel.vue'),
                    },
                    {
                        path: ':uuid/edit',
                        name: 'editJob',
                        props: true,
                        meta: {
                            module: 'admin',
                            access: 'private',
                            submodule: 'jobs'
                        },
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/jobs/JobsDataPanel.vue'),
                    },


                ]
            },


        ]
    },
    {
        path: '/my-user',
        name: 'userArea',
        meta: {
            module: 'user',
            access: 'private'
        },
        component: () => import(/* webpackChunkName: "user" */ '../views/MyUserArea.vue')
    },
    {
        path: '/password-recover/:code',
        name: 'recoverPassword',
        props: true,
        meta: {
            module: 'app',
            access: 'public'
        },
        component: () => import(/* webpackChunkName: "recoverpassword" */ '@/views/RecoverPassword.vue')
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from/*, savedPosition*/) {
        if (to.hash) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    const el = document.querySelector(to.hash);
                    if (el) {
                        const yOffset = 80; // adjust for navbar height
                        const y = el.getBoundingClientRect().top + window.scrollY - yOffset;

                        window.scrollTo({top: y, behavior: "smooth"});
                    }
                    resolve(false); // prevent default scroll
                }, 800); // wait 300ms (tweak depending on your rendering time)
            });
        }
        const isAuthorityDetailNavigation =
            to.path.includes('/authorities/competition/') ||
            from.path.includes('/authorities/competition/') ||
            to.path.includes('/authorities/foreign-investments/') ||
            from.path.includes('/authorities/foreign-investments/')

        if (!to.path.includes('/decisions/') && !to.meta.preserveScroll && !isAuthorityDetailNavigation)
            return new Promise(() => {
                setTimeout(() => {
                    window.scrollTo({left: 0, top: 0, behavior: "smooth"});
                }, 800); // wait 300ms (tweak depending on your rendering time)
            });
        else
            return {}
    },
})

export default router
